(function () {
  'use strict';

  class VisualProductResults {
    constructor({ grid, count, source, idPrefix }) {
      this.grid = grid;
      this.count = count;
      this.source = source;
      this.idPrefix = idPrefix || 'VisualProducts';
      this.bind();
    }

    bind() {
      this.grid.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-visual-product-tab]');
        if (tab) this.activateProductType(tab.dataset.visualProductTab);
      });

      this.grid.addEventListener('keydown', (event) => {
        const tab = event.target.closest('[data-visual-product-tab]');
        if (!tab || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const tabs = [...this.grid.querySelectorAll('[data-visual-product-tab]')];
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const nextTab = tabs[(tabs.indexOf(tab) + direction + tabs.length) % tabs.length];
        this.activateProductType(nextTab.dataset.visualProductTab);
        nextTab.focus();
      });
    }

    setSource(source) {
      this.source = source;
    }

    clear() {
      this.grid.innerHTML = '';
      if (this.count) this.count.textContent = '';
    }

    render(products, groups, preferredType) {
      const productList = Array.isArray(products) ? products : [];
      if (!productList.length) {
        this.clear();
        return 0;
      }

      const wallMurals = Array.isArray(groups?.wallMurals)
        ? groups.wallMurals
        : productList.filter((product) => product.productType === 'Wall Mural');
      const wallpapers = Array.isArray(groups?.wallpapers)
        ? groups.wallpapers
        : productList.filter((product) => product.productType === 'Wallpaper');
      const orderedGroups = preferredType === 'Wall Mural'
        ? [['wall-murals', 'Poster Duvar Kağıdı', wallMurals], ['wallpapers', 'Duvar Kağıdı', wallpapers]]
        : [['wallpapers', 'Duvar Kağıdı', wallpapers], ['wall-murals', 'Poster Duvar Kağıdı', wallMurals]];
      const availableGroups = orderedGroups.filter(([, , items]) => Array.isArray(items) && items.length);

      if (!availableGroups.length) {
        this.clear();
        return 0;
      }

      const total = availableGroups.reduce((sum, [, , items]) => sum + items.length, 0);
      if (this.count) this.count.textContent = `${total} ürün`;
      const activeType = availableGroups[0][0];
      const tabs = availableGroups.map(([type, label, items], index) => {
        const tabId = `${this.idPrefix}Tab-${type}`;
        const panelId = `${this.idPrefix}Panel-${type}`;
        return '<button class="visual-search-type-tab' + (index === 0 ? ' is-active' : '') + '" type="button" role="tab"' +
          ' id="' + tabId + '" aria-controls="' + panelId + '" aria-selected="' + (index === 0) + '"' +
          ' tabindex="' + (index === 0 ? '0' : '-1') + '" data-visual-product-tab="' + type + '">' +
          '<span>' + label + '</span><strong>' + items.length + '</strong></button>';
      }).join('');
      const panels = availableGroups.map(([type, label, items]) => {
        const tabId = `${this.idPrefix}Tab-${type}`;
        const panelId = `${this.idPrefix}Panel-${type}`;
        return '<section class="visual-search-product-panel" role="tabpanel" id="' + panelId + '"' +
          ' aria-labelledby="' + tabId + '" data-visual-product-panel="' + type + '"' + (type === activeType ? '' : ' hidden') + '>' +
          '<h4 class="visually-hidden">' + label + '</h4>' +
          '<div class="visual-search-results__grid">' + items.map((product) => this.productCard(product)).join('') + '</div>' +
          '</section>';
      }).join('');

      this.grid.innerHTML = '<div class="visual-search-type-tabs" role="tablist" aria-label="Ürün türü">' + tabs + '</div>' + panels;
      return total;
    }

    activateProductType(type) {
      this.grid.querySelectorAll('[data-visual-product-tab]').forEach((tab) => {
        const active = tab.dataset.visualProductTab === type;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.grid.querySelectorAll('[data-visual-product-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.visualProductPanel !== type;
      });
    }

    productCard(product) {
      const title = this.escape(product.title || 'Duvar kağıdı deseni');
      const rawImage = String(product.image || '');
      const productUrl = this.duvarkaplaUrl(product.url);
      if (!rawImage || !productUrl) return '';
      const imageUrl = rawImage + (rawImage.includes('?') ? '&' : '?') + 'width=640';
      const attributedUrl = window.DuvarkaplaFunnel?.attributedUrl(productUrl, this.source) || productUrl;
      return '<a class="visual-search-card" href="' + this.escape(attributedUrl) + '" aria-label="' + title + ' ürününü görüntüle"' +
        ' data-funnel-product-link data-funnel-source="' + this.escape(this.source) + '"' +
        ' data-funnel-product-handle="' + this.escape(product.handle) + '">' +
        '<div class="visual-search-card__image"><img src="' + this.escape(imageUrl) + '" alt="' + title + '" loading="lazy"></div>' +
        '<span class="visual-search-card__open" aria-hidden="true">↗</span></a>';
    }

    duvarkaplaUrl(value) {
      if (!value) return '';
      try {
        const url = new URL(String(value), window.location.origin);
        const allowedHosts = new Set([window.location.hostname, 'duvarkapla.com', 'www.duvarkapla.com']);
        return allowedHosts.has(url.hostname) ? url.href : '';
      } catch {
        return '';
      }
    }

    escape(value) {
      return String(value || '').replace(/[&<>"']/g, (character) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
      })[character]);
    }
  }

  window.DuvarkaplaVisualProductResults = VisualProductResults;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-funnel-product-link]');
    if (!link) return;
    window.DuvarkaplaFunnel?.trackProductClick(link.dataset.funnelSource, { productHandle: link.dataset.funnelProductHandle });
  }, true);
})();
